import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Subject } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";

@Component({
  selector: "app-groups",
  templateUrl: "./groups.component.html",
  styleUrls: ["./groups.component.css"]
})
export class GroupsComponent implements OnInit {
  public groupData = {groupname : [], "poolId" : localStorage.getItem("poolId"), "region" : localStorage.getItem("region")};
  public data;
  public submitted: boolean = false;
  public cred = {"poolId":localStorage.getItem("poolId"), "region": localStorage.getItem("region")};
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      rowCallback: (row: Node, data: Object, index: number) => {
        $("#check", row).unbind("click");
        $("#check", row).bind("click", () => {
          const index = this.groupData.groupname.indexOf(data[1]);
          if ($("#check", row).is(":checked")) {
            if (index === -1) {
              // console.log(data[1].splice('<a _ngcontent-c5="">',1))

              this.groupData.groupname.push(data[1]);
              console.log(this.groupData.groupname);
            }
          } else {
            this.groupData.groupname.splice(index, 1);
            console.log(this.groupData.groupname);
          }
          console.log(this.groupData.groupname.length);
          if (this.groupData.groupname.length > 1) {
            this.submitted = true;
          } else if (this.groupData.groupname.length <= 1) {
            this.submitted = false;
          }
        });

        return row;
      }
    };
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 2000);

    this.getGroupList();
  }

  getGroupList() {
    return this.dataService.getGroupList().subscribe((Data: any) => {
      console.log(Data);
      if (Data.Status == "Error") {
        // alert(Data.Error.message);
        this.toastr.errorToastr(Data.Error.message,"oops!")
      } else {
        this.data = Data.Data.Groups;
        this.dtTrigger.next();
      }
    });
  }

  updateGroupRolePolicy(groupName) {
    console.log(groupName);
    this.router.navigate(["/update-policy", { groupName }]);
  }

  viewPolicy(group) {
    console.log(group);
    this.router.navigate(["/list-policy", { groupName: group }]);
  }

  deleteSingleGroup(group) {
    this.groupData.groupname=[]
    if(this.groupData.groupname.length == 0){
    this.groupData.groupname.push(group);
    }
    if(this.groupData.groupname.length == 1){
      this.deleteGroup();
    }
  }

  deleteGroup() {
    console.log(this.groupData.groupname);
    var sure = confirm("Are you sure,Do you want to delete?");
    if (sure == true) {
      this.dataService.deleteGroup(this.groupData).subscribe((newData: any) => {
        if(typeof newData == 'string')
        newData = JSON.parse(newData); 
        console.log(newData);
        if (newData.Status == "Error") {
          console.log(newData.Error.message);
          // alert(newData.Error.message);
          this.toastr.errorToastr(newData.Error.message,"oops!")
        } else if (newData.Status == "Success") {
          // alert("Group Deleted Successfully");
          this.toastr.successToastr("Group Deleted Successfully","Success!")
          location.reload();
        }
      });
    } else {
      console.log("Cancel");
    }
  }
}
